module.exports = __webpack_public_path__ + "img/Group 96.5f7184f0.png";